module.exports = __webpack_public_path__ + "img/title-1.e1f7cba5.png";